import React from "react";
import { twMerge } from "tailwind-merge";
import { Icons } from "./Icon";

export default function CredLogo({ className }: { className?: string }) {
  return (
    <div className={twMerge("mt-8", className)}>
      <Icons.logo />
    </div>
  );
}
